import type { IconSvgObject } from './types';

const CheckmarkSquare03Icon: IconSvgObject = [
  ["path", { d: "M21.4999 10V19.5C21.4999 20.6046 20.6045 21.5 19.4999 21.5H4.49994C3.39537 21.5 2.49994 20.6046 2.49994 19.5V4.5C2.49994 3.39543 3.39537 2.5 4.49994 2.5H14.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.00006 11.5C8.00006 11.5 10.0001 12 11.5001 15C11.5001 15 16.5589 5.83333 21.5001 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CheckmarkSquare03Icon;
